
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/webhooks/webhook-verification",
      function () {
        return require("private-next-pages/docs/api/webhooks/webhook-verification.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/webhooks/webhook-verification"])
      });
    }
  